module.exports = __webpack_public_path__ + "static/media/massage_white.af34b620.svg";